<template>
	<div>
		<v-toolbar app flat dark color="primary" class="map-toolbar" :class="{'is-inverted' : mapType != 'roadmap'}">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title v-if="device">
				{{ device.name ? device.name : '' | capitalize }}

				<span class="v-toolbar__subtitle" v-if="!detectingRange">
                    <span v-if="device.getState().accuracy < 20">Je E-finder bevindt zich hier </span>
                    <span v-else>Je E-finder bevindt zich in de cirkel </span>
                    <span v-if="device.isMoving()"> en is in beweging</span>
                    <span v-else> en staat stil</span>
                </span>

				<span class="v-toolbar__subtitle" v-else>
                    <span v-if="bleConnection">Je E-finder is in de buurt</span>
                    <span v-else>Geen signaal van je E-finder</span>
                </span>
			</v-toolbar-title>
			<v-btn icon @click="goToNotifications()">
				<v-icon>
					notifications
				</v-icon>
				<span v-if="unreadNotificationCount > 0" class="new-notifications"></span>
			</v-btn>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="map-overlay" v-if="detectingRange">
			<v-container fill-height>
				<v-container>
					<range-detector></range-detector>
				</v-container>
			</v-container>
		</v-content>

		<uf-drawer
			:class="{'is-inverted' : mapType != 'roadmap'}"
			:expanded="detailedView"
			:offset="-20"
			@close="detailedView = false"
			@open="detailedView = true"
			@press="focusDrawer"
			v-if="device"
		>

			<v-layout slot="above" justify-space-between>
				<uf-value label="precisie" :type="detectingRange ? '' : 'm'">
					<span v-if="detectingRange">-</span>
					<span v-else v-text="device.latest_state.accuracy">-</span>
				</uf-value>

				<v-btn absolute fab right style="bottom: 100%" class="mb-4" @click="toggleMapType" v-if="!detectingRange">
					<v-icon>{{ mapType === 'roadmap' ? 'satellite' : 'map' }}</v-icon>
				</v-btn>

				<v-btn absolute fab left :disabled="!bleConnection" style="bottom: 100%" class="mb-4" @click="detectingRange = true" v-if="device.isDetectingRange()">
					<v-icon>speaker_phone</v-icon>
				</v-btn>

				<uf-value label="datum en tijd">
					{{ device.getLastFormattedUpdate('D MMM HH:mm') }}
				</uf-value>
				<uf-value label="batterij" :type="!device.latest_state.battery_charging ? '%' : ''">
					<div v-if="device.latest_state.battery_charging">
						<i class="fa fa-battery-bolt"></i>
					</div>
					<span v-else>{{ device.latest_state.battery_percentage }}</span>
				</uf-value>
			</v-layout>

			<v-card-title slot="top" class="e-connectz_card-title has-top-whitespace">
				<v-layout justify-space-between align-start>
					<div>
						<h3>{{ device.name }}</h3>
						<p>
							{{ device.getSubtitle() }}
							- {{ device.getStateMessageType() }}
						</p>
					</div>
					<v-btn icon @click="gotoHistory" v-if="device.states && device.states.length">
						<v-icon>history</v-icon>
					</v-btn>
				</v-layout>
				<p :style="{ color: device.getMarker().color }">{{ device.getMessage(messageIndex) }}</p>
			</v-card-title>

			<v-list>
				<v-list-tile class="mx-2 mt-4">
					<v-select
						:append-icon="device.target_mode == device.latest_state.state_id ? 'done' : 'hourglass_empty'"
						:value="device.target_mode"
						:items="[{text: 'Standaard', value: '0'}, {text: 'Zoeken', value: '1'}, {text: 'Pinpointer', value: '3'}]"
						label="Profiel"
						placeholder="Maak een keuze..."
						ref="selectBoxProfile"
						@change="setMode"
					>
					</v-select>
				</v-list-tile>

<!--				<v-divider class="mt-3 mb-3"></v-divider>-->

<!--				<v-list-tile class="mx-2 mt-4">-->
<!--					<v-select-->
<!--						:append-icon="device.target_profile == device.latest_state.profile_id ? 'done' : 'hourglass_empty'"-->
<!--						:value="device.target_profile"-->
<!--						:items="[{text: 'Standaard', value: '0'}, {text: 'Voertuig', value: '1'}]"-->
<!--						label="Gevoeligheid"-->
<!--						placeholder="Maak een keuze..."-->
<!--						ref="selectBoxSensitivity"-->
<!--						@change="setProfile"-->
<!--					>-->
<!--					</v-select>-->
<!--				</v-list-tile>-->

				<v-divider class="mt-3 mb-3"></v-divider>

				<v-dialog v-model="locationLockDialog" persistent max-width="290">

					<template v-slot:activator="{ on }">
						<v-list-tile one-line v-on="on">
							<v-list-tile-avatar>
								<v-icon>lock</v-icon>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>Virtuele bewaker modus</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-switch
									readonly
									color="success"
									v-model="locationLockSwitch">
								</v-switch>
							</v-list-tile-action>
						</v-list-tile>
					</template>

					<v-card v-if="device && !device.location_lock">
						<v-card-title class="headline">Beweging meldingen</v-card-title>
						<v-card-text>Je gaat in deze modus berichten ontvangen als je E-finder beweegt.
							Weet je zeker dat je deze modus wil activeren?
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn flat @click="locationLockDialog = false;">Annuleren</v-btn>
							<v-btn color="red darken-1" flat
								   @click="locationLockDialog = false; setLocationLock(true);">Activeren
							</v-btn>
						</v-card-actions>
					</v-card>
					<v-card v-else>
						<v-card-title class="headline">Beweging meldingen</v-card-title>
						<v-card-text>Je ontvangt nu geen berichten meer als je E-finder beweegt. Weet je
							zeker dat je deze modus wilt deactiveren?
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn flat @click="locationLockDialog = false;">Annuleren</v-btn>
							<v-btn color="green darken-1" flat
								   @click="locationLockDialog = false; setLocationLock(false);">
								Deactiveren
							</v-btn>
						</v-card-actions>
					</v-card>

				</v-dialog>

				<v-dialog v-model="securityServiceModeDialog" persistent max-width="290">

					<template v-slot:activator="{ on }">
						<v-list-tile one-line v-on="on">
							<v-list-tile-avatar>
								<v-icon>report</v-icon>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>SMC Alarm Assistance</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-switch
									@click.prevent
									readonly
									color="success"
									v-model="securityServiceModeSwitch">
								</v-switch>
							</v-list-tile-action>
						</v-list-tile>
					</template>

					<v-card v-if="!device.security_service_mode">
						<v-card-title class="headline">SMC Alarm Assistance</v-card-title>
						<v-card-text>
							<p>
							Hiermee schakel je de diensten in van
							SMC Alarm Assistance. Aan deze service
							zijn kosten verbonden. Weet je zeker dat je
							hiervan gebruik wilt maken?
							Voor meer informatie, Algemene Voorwaarden
								en Privacy Statement van SMC druk <a @click="openUrl('http://www.smc-alarmcentrale.nl/e-finder')">hier</a>.
							</p><p>
							Als je op activeren drukt, krijgt SMC inzage
							in je gegevens en zul je per omgaande worden
							gebeld door een medewerker van SMC.
							Na telefonisch overleg en akkoord zullen
							zij je desgewenst bijstaan.</p>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn flat @click.native="securityServiceModeDialog = false;">Annuleren</v-btn>
							<v-btn color="red darken-1" flat
								   @click.native="securityServiceModeDialog = false; setSecurityServiceMode(true);">
								Activeren
							</v-btn>
						</v-card-actions>
					</v-card>
					<v-card v-else>
						<v-card-title class="headline">SMC Alarm Assistance</v-card-title>
						<v-card-text>Hiermee schakelt je de diensten van SMC Alarm Service uit. Weet je zeker dat
							je geen gebruik meer wilt maken van de SMC Alarm Service? Als je op akkoord drukt zal
							de bijstand worden gestaakt.
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn flat @click.native="securityServiceModeDialog = false;">Annuleren</v-btn>
							<v-btn color="green darken-1" flat
								   @click.native="securityServiceModeDialog = false; setSecurityServiceMode(false);">
								Deactiveren
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-divider class="mt-3 mb-3"></v-divider>

				<v-list-tile one-line ripple @click="gotoEdit()">
					<v-list-tile-content>
						<v-list-tile-title>Apparaat gegevens</v-list-tile-title>
					</v-list-tile-content>
					<v-list-tile-action align-end>
						<v-btn icon>
							<v-icon color="grey lighten-1">chevron_right</v-icon>
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>

				<v-divider class="mt-3 mb-3"></v-divider>

				<v-list-tile>
					<v-btn depressed block large
						   color="primary"
						   @click="openNavigation"
						   class="white--text">
						Navigeren naar deze E-finder
					</v-btn>
				</v-list-tile>

				<v-list-tile v-if="device.hasStreetView()">
					<v-btn depressed block large
						   color="primary"
						   class="white--text"
						   @click="openStreetView">
						Bekijk in streetview
					</v-btn>
				</v-list-tile>

				<v-list-tile one-line></v-list-tile>
			</v-list>

		</uf-drawer>

		<v-dialog v-model="dialogError" persistent max-width="290">
			<v-card>
				<v-card-title class="headline">Error</v-card-title>
				<v-card-text>Exacte locatie kan niet ingeschakeld worden.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="darken-1" flat @click.native="dialogError = false">Ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
  import TweenLite from 'gsap';
  import { mapGetters } from 'vuex';

  export default {
    timers: {
      loadDevice: { time: 60000, autostart: true, repeat: true },
    },
    computed: {
      ...mapGetters(['unreadNotificationCount']),
      bleMessage() {
        return this.$store.state.ble.message;
      },
      bleError() {
        return this.$store.state.ble.error;
      },
	  bleConnection() {
	    return this.$store.state.ble.rssi !== null;
	  },
      device() {
        return this.$store.getters.device;
      },
      messageIndex() {
        return this.$store.state.messageIndex;
      },
      mapType() {
        return this.$store.state.map.mapTypeId;
      },
      userLocation() {
        return this.$store.state.location.coordinates;
      }
    },
    data: () => ({
	  detectingRange: false,
      isLoading: false,
      dialogError: false,
      detailedView: false,
      armedStateDialog: false,
      locationLockDialog: false,
      securityServiceModeDialog: false,
      shortRangeDialog: false,
      locationLockSwitch: false,
      securityServiceModeSwitch: false,
    }),
    watch: {
      signalStrength(value) {
        TweenLite.to(this.$data, 1, {
          easedSignalStrength: value
        });
      },
      device(device) {
        if (device.isDetectingRange && device.isDetectingRange()) {
          return this.$store.dispatch('bleConnect', device.eid);
        }
        return this.$store.dispatch('bleDisconnect', device.eid);
      }
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      goBack() {
        if(this.detectingRange){
          this.detectingRange = false;
		}else{
          this.gotoOverview();
		}
	  },
      openUrl(url) {
        const win = window.open(url, '_system');
        win.focus();
	  },
      gotoOverview() {
        this.$router.push({name: 'devices.index'});
      },
      goToNotifications() {
        this.$router.push('/notifications');
      },
      gotoHistory() {
        this.$router.push({name: 'devices.show.history', params: { id: this.device.id }});
      },
      gotoEdit() {
        this.$router.push({name: 'devices.edit', params: { id: this.device.id }});
      },
      gotoActivation() {
        this.$router.replace({name: 'devices.activate', params: { id: this.device.id }});
      },
      openNavigation() {
        // eslint-disable-next-line
        const win = window.open(`https://www.google.com/maps/dir/?api=1&destination=${this.device.getLocation().lat}%20${this.device.getLocation().lng}`, '_system');
        win.focus();
      },
      openStreetView() {
        // eslint-disable-next-line
        const win = window.open(`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${this.device.getLocation().lat},${this.device.getLocation().lng}`, '_system');
        win.focus();
      },
      toggleMapType() {
        this.$store.dispatch('toggleMapType');
      },
      setLocationLock(value) {
        const initialValue = this.locationLockSwitch;
        this.locationLockSwitch = value;
        this.$store.dispatch('updateDevice', {
          id: this.$route.params.id,
          data: { location_lock: value },
        })
          .then(
            () => {
              console.log(`Location lock mode value: ${value}`);
            },
            reason => {
              this.locationLockSwitch = initialValue;
            })
          .catch((e) => {
            this.locationLockSwitch = initialValue;
          });
      },
      setMode(value) {
        this.$store.dispatch('updateDevice', {
          id: this.$route.params.id,
          data: { target_mode: value },
        })
          .catch((e) => {
            this.dialogError = 'Profiel kan niet ingeschakeld worden.';
          });
      },
      setProfile(value) {
        this.$store.dispatch('updateDevice', {
          id: this.$route.params.id,
          data: { target_profile: value },
        })
          .catch((e) => {
            this.dialogError = 'Gevoelighied kan niet ingeschakeld worden.';
          });
      },
      setSecurityServiceMode(value) {
        const initialValue = this.securityServiceModeSwitch;

        this.securityServiceModeSwitch = value;

        this.$store.dispatch('updateDevice', {
          id: this.$route.params.id,
          data: { security_service_mode: value },
        })
          .then(
            () => {
              console.log(`Security mode value: ${value}`);
            },
            reason => {
              this.securityServiceModeSwitch = initialValue;
            })
          .catch((e) => {
            this.securityServiceModeSwitch = initialValue;
          });
      },
      loadDevice() {
        this.$store.dispatch('selectDevice', this.$route.params.id)
          .then(() => {
            this.$nextTick(() => {
              if (this.device && this.device.isWaitingForActivation()) {
                this.gotoActivation();
                this.locationLockSwitch = this.device.location_lock;
                this.securityServiceModeSwitch = this.device.security_service_mode;
              }
            });
          })
		  .catch((e) => {
		    this.gotoOverview();
		  });

        this.locationLockSwitch = this.device ? this.device.location_lock : false;
        this.securityServiceModeSwitch = this.device ? this.device.security_service_mode: false;

      },
      focusDrawer() {
        this.$refs.selectBoxProfile.blur();
      }
    },
    created() {
      this.loadDevice();
    }
  };
</script>

<style lang="stylus">
	.map-overlay {
		position: fixed;
		top: 0;
		width: 100%;
		bottom: 150px; // The bottom of the map when drawer is visible
		background: white;
	}

	.e-connectz_card-title {
		position: relative;
		display: block;

		&:before {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			height: 16px;
			background-image: linear-gradient(to top, rgba(#455B63, .075), rgba(#455B63, 0))
		}

		.v-btn {
			margin-top: 0;
		}

		h3 {
			font-size: 1.5rem;
			font-weight: normal;
		}

		p {
			margin: 0;
			color: rgba(#17263C, .55);
		}
	}

	.rssi-meter {
		position: absolute;
		top: -2.5rem;
		left: 1.5rem;
		width: 100%;
		transform-origin: left top;
		transform: rotate(-90deg);
		z-index: 9999;
		pointer-events: none;
	}

	.stop-range-detector-button {
		position: absolute;
		top: -3rem;
		left: 50%;
		margin-left: -.25rem;
		transform: translate(-50%, -100%);
	}
</style>
